import { render } from "./LogOut.vue?vue&type=template&id=2d195441"
import script from "./LogOut.vue?vue&type=script&lang=ts"
export * from "./LogOut.vue?vue&type=script&lang=ts"
script.render = render

export default script